
import { Component, Vue } from 'vue-property-decorator';
import QvInput from '@/components/FormComponents/QvInput.vue';
import { ValidationObserver } from 'vee-validate';
import { ConfigurationStore } from '@/store/modules';
import { FreeConsultRequest } from '@/store/models/configuration';

@Component({
  meta: {
    title: 'TryForFree'
  },
  components: {
    QvInput,
    ValidationObserver
  }
})
export default class TryForFree extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };
  freeConsultRequest: FreeConsultRequest = {} as FreeConsultRequest;

  async onSubmit() {
    await ConfigurationStore.sendFreeConsultRequest(this.freeConsultRequest);
    this.$q.notify({
      type: 'positive',
      message: `Free consult request sent`
    });
    this.$refs.observer.reset();
    this.$emit('close');
  }
  onReset() {
    requestAnimationFrame(() => {
      this.$refs.observer.reset();
      this.$emit('close');
    });
  }
}
